<template>
<svg id="radio-button" :class="{selected: active}" data-name="Radio active" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" width="20" height="20">
  <path d="M12,4a8,8,0,1,1-8,8,8.009,8.009,0,0,1,8-8m0-2A10,10,0,1,0,22,12,10,10,0,0,0,12,2Z" transform="translate(-2 -2)"/>
  <circle v-if="active" cx="10" cy="10" r="5"/>
</svg>
</template>

<script>
   export default {
     props: ['active']
   }
</script>

<style lang="less" scoped>
    @import '../_theme';
    
    #radio-button {
        fill: @text-color;
    }
    #radio-button.selected {
        fill: @main-button-color;
    }
    svg {
        vertical-align: middle;
    }
</style>


// WEBPACK FOOTER //
// src/components/RadioButton.vue